import {
  useContext,
  useEffect,
} from 'react';
import { AppContext } from '../app/AppProvider.component';
import { getBrand } from '../../pages/ai-chat/ai-chat.utilities';
import { Brand } from '../../constants/common.constants';

export const ThemeHandlerComponent = (): null => {
  const {
    appState
  } = useContext(AppContext);

  useEffect(() => {
    const brandCssClasses: Partial<Record<Brand, string>> = {
      [Brand.OSMOSIS_AI]: 't-naa-osmosis-ai',
      [Brand.AI_COACH]: 't-naa-ai-coach',
    };
    const activeCssClass = brandCssClasses[getBrand(appState)];

    Object.values(brandCssClasses).forEach((cssClass) => {
      if (cssClass === activeCssClass) {
        document.body.classList.add(cssClass);
      } else {
        document.body.classList.remove(cssClass);
      }
    });
  }, [appState.appLinkData]);

  return null;
};

const ThemeHandler = ThemeHandlerComponent;
export default ThemeHandler;
